import { Box, styled, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode, useState } from 'react';
import Sidebar from '@components/Sidebar/Sidebar.component';
import NavBar from '@components/NavBar/NavBar.component';
import AdminPageHeader from '@components/AdminPageHeader/AdminPageHeader.component';
import RequestFeature from '@components/RequestFeature/RequestFeature.component';

interface LayoutProps {
  children: ReactNode;
  title: string;
}

const AdminLayout: React.FC<LayoutProps> = ({ children }) => {

  const [showSidebar, setShowSidebar] = useState(false);
  const [showRequestFeature, setShowRequestFeature] = useState(false)

  const handleSidebar = () => {
      setShowSidebar(prev => !prev);
  }

  function handleRequestFeature(){
      setShowRequestFeature(true)
  }

  return (

    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh"}}>
        <NavBar burgerMenuClick={handleSidebar}/>

        <Box sx={{ display: "flex", flexGrow: 1, position: 'relative' }}>
            <Sidebar handleSidebar={handleSidebar} showSidebar={showSidebar} handleRequestFeature={handleRequestFeature}/>

            <RequestFeature open={showRequestFeature} onClose={() => setShowRequestFeature(false)} />

            <Box sx={{ flexGrow: 1, backgroundColor: "#f9f9f9", minHeight: "100%", overflowY: 'hidden' }}>
                {children}
            </Box>
        </Box>
    </Box>
  );
};

export default AdminLayout; 